import { render, staticRenderFns } from "./Relocationallowance.vue?vue&type=template&id=2bd0f76c&scoped=true&"
import script from "./Relocationallowance.vue?vue&type=script&lang=js&"
export * from "./Relocationallowance.vue?vue&type=script&lang=js&"
import style0 from "./Relocationallowance.vue?vue&type=style&index=0&id=2bd0f76c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd0f76c",
  null
  
)

export default component.exports